import { application } from "./application"

import AddressSelectController from "./address_select_controller"
application.register("address-select", AddressSelectController)

import AffiliationDatesController from "./affiliation_dates_controller"
application.register("affiliation-dates", AffiliationDatesController)

import AffiliationFacilitatorWarningController from "./affiliation_facilitator_warning_controller"
application.register("affiliation-facilitator-warning", AffiliationFacilitatorWarningController)

import AllocationRefController from "./allocation_ref_controller"
application.register("allocation-ref", AllocationRefController)

import AnchorHighlightController from "./anchor_highlight_controller"
application.register("anchor-highlight", AnchorHighlightController)

import AnswerOptionsController from "./answer_options_controller"
application.register("answer-options", AnswerOptionsController)

import AttendanceStatusController from "./attendance_status_controller"
application.register("attendance-status", AttendanceStatusController)

import AssetPickerController from "./asset_picker_controller"
application.register("asset-picker", AssetPickerController)

import AutosaveController from "./autosave_controller"
application.register("autosave", AutosaveController)

import BackgroundVideoController from "./background_video_controller"
application.register("background-video", BackgroundVideoController)

import CalloutPreviewController from "./callout_preview_controller"
application.register("callout-preview", CalloutPreviewController)

import CarouselController from "./carousel_controller"
application.register("carousel", CarouselController)

import ChartTooltipFooterController from "./chart_tooltip_footer_controller"
application.register("chart-tooltip-footer", ChartTooltipFooterController)

import CeLicensePickerController from "./ce_license_picker_controller"
application.register("ce-license-picker", CeLicensePickerController)

import ChipSelectController from "./chip_select_controller"
application.register("chip-select", ChipSelectController)

import CocoonController from "./cocoon_controller"
application.register("cocoon", CocoonController)

import CollectionController from "./collection_controller"
application.register("collection", CollectionController)

import ConfirmEmailController from "./confirm_email_controller"
application.register("confirm-email", ConfirmEmailController)

import ColumnToggleController from "./column_toggle_controller"
application.register("column-toggle", ColumnToggleController)

import EditToggleController from "./edit_toggle_controller"
application.register("edit-toggle", EditToggleController)

import FieldRequiredController from "./field_required_controller"
application.register("field-required", FieldRequiredController)

import DirtyFormController from "./dirty_form_controller"
application.register("dirty-form", DirtyFormController)

import DismissController from "./dismiss_controller"
application.register("dismiss", DismissController)

import FlipCardController from "./flip_card_controller"
application.register("flip-card", FlipCardController)

import EventStaffBioController from "./event_staff_bio_controller"
application.register("event-staff-bio", EventStaffBioController)

import ExpandableCardController from "./expandable_card_controller"
application.register("expandable-card", ExpandableCardController)

import ExpandableCardsController from "./expandable_cards_controller"
application.register("expandable-cards", ExpandableCardsController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import ExpandAllController from "./expand_all_controller"
application.register("expand-all", ExpandAllController)

import FilePreviewController from "./file_preview_controller"
application.register("file-preview", FilePreviewController)

import FieldOptionsController from "./field_options_controller"
application.register("field-options", FieldOptionsController)

import FormErrorsController from "./form_errors_controller"
application.register("form-errors", FormErrorsController)

import FormFieldsSortableController from "./form_fields_sortable_controller"
application.register("form-fields-sortable", FormFieldsSortableController)

import GrantDetailsController from "./grant_details_controller"
application.register("grant-details", GrantDetailsController)

import GrantSelectController from "./grant_select_controller"
application.register("grant-select", GrantSelectController)

import InactiveToggleController from "./inactive_toggle_controller"
application.register("inactive-toggle", InactiveToggleController)

import NavigateSelectController from "./navigate_select_controller"
application.register("navigate-select", NavigateSelectController)

import OptimisticBookmarkController from "./optimistic_bookmark_controller"
application.register("optimistic-bookmark", OptimisticBookmarkController)

import SpecifyOptionController from "./specify_option_controller"
application.register("specify-option", SpecifyOptionController)

import OrgToggleController from "./org_toggle_controller"
application.register("org-toggle", OrgToggleController)

import PaginatedFieldsController from "./paginated_fields_controller"
application.register("paginated-fields", PaginatedFieldsController)

import PanelToggleController from "./panel_toggle_controller"
application.register("panel-toggle", PanelToggleController)

import QuestionLibraryController from "./question_library_controller"
application.register("question-library", QuestionLibraryController)

import PasswordToggleController from "./password_toggle_controller"
application.register("password-toggle", PasswordToggleController)

import SearchTypeSelectController from "./search_type_select_controller"
application.register("search-type-select", SearchTypeSelectController)

import PrefetchLazyController from "./prefetch_lazy_controller"
application.register("prefetch-lazy", PrefetchLazyController)

import PrintOptionsController from "./print_options_controller"
application.register("print-options", PrintOptionsController)

import ReminderPreviewController from "./reminder_preview_controller"
application.register("reminder-preview", ReminderPreviewController)

import RevealSectionController from "./reveal_section_controller"
application.register("reveal-section", RevealSectionController)

import RhinoSourceController from "./rhino_source_controller"
application.register("rhino-source", RhinoSourceController)

import ScholarshipPreviewController from "./scholarship_preview_controller"
application.register("scholarship-preview", ScholarshipPreviewController)

import ScholarshipStatusToggleController from "./scholarship_status_toggle_controller"
application.register("scholarship-status-toggle", ScholarshipStatusToggleController)

import SearchBoxController from "./search_box_controller"
application.register("search-box", SearchBoxController)

import SearchableCheckboxController from "./searchable_checkbox_controller"
application.register("searchable-checkbox", SearchableCheckboxController)

import SearchableSelectController from "./searchable_select_controller"
application.register("searchable-select", SearchableSelectController)

import SectionFilterController from "./section_filter_controller"
application.register("section-filter", SectionFilterController)

import PrimaryTagController from "./primary_tag_controller"
application.register("primary-tag", PrimaryTagController)

import FormSectionToggleController from "./form_section_toggle_controller"
application.register("form-section-toggle", FormSectionToggleController)

import ShareUrlController from "./share_url_controller"
application.register("share-url", ShareUrlController)

import ScrollToTopController from "./scroll_to_top_controller"
application.register("scroll-to-top", ScrollToTopController)

import SliderController from "./slider_controller"
application.register("slider", SliderController)

import SortableController from "./sortable_controller"
application.register("sortable", SortableController)

import SubmitOnceController from "./submit_once_controller"
application.register("submit-once", SubmitOnceController)

import TagLinkLoadingController from "./tag_link_loading_controller"
application.register("tag-link-loading", TagLinkLoadingController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import TableSortController from "./table_sort_controller"
application.register("table-sort", TableSortController)

import TagsSyncListHeightsController from "./tags_sync_list_heights_controller"
application.register("tags-sync-list-heights", TagsSyncListHeightsController)

import TagsCombinationHighlightController from "./tags_combination_highlight_controller"
application.register("tags-combination-highlight", TagsCombinationHighlightController)

import TimeframeController from "./timeframe_controller"
application.register("timeframe", TimeframeController)

import ToggleDetailsController from "./toggle_details_controller"
application.register("toggle-details", ToggleDetailsController)

import ToggleUserIconController from "./toggle_user_icon_controller"
application.register("toggle-user-icon", ToggleUserIconController)

import RemoteSelectController from "./remote_select_controller"
application.register("remote-select", RemoteSelectController)

import InvoiceeController from "./invoicee_controller"
application.register("invoicee", InvoiceeController)

import NestedItemsController from "./nested_items_controller"
application.register("nested-items", NestedItemsController)

import MixedChartController from "./mixed_chart_controller"
application.register("mixed-chart", MixedChartController)

import UsMapChartController from "./us_map_chart_controller"
application.register("us-map-chart", UsMapChartController)

import WorldMapChartController from "./world_map_chart_controller"
application.register("world-map-chart", WorldMapChartController)

import CurrencyInputController from "./currency_input_controller"
application.register("currency-input", CurrencyInputController)

import BulkPaymentAttendeesController from "./bulk_payment_attendees_controller"
application.register("bulk-payment-attendees", BulkPaymentAttendeesController)

import ConditionalFieldsController from "./conditional_fields_controller"
application.register("conditional-fields", ConditionalFieldsController)

